import React from "react";

export default function MaterialErrorCard({ error, onRetry, onClose, variant = "panel" }) {
  const message = "Failed to load Material components. Please try again.";
  const isPopout = variant === "popout";

  const containerStyle = isPopout
    ? {
      position: "fixed",
      bottom: 24,
      right: 24,
      width: 460,
      minWidth: 280,
      maxWidth: 500,
      height: "80vh",
      zIndex: 1030,
      display: "flex",
      flexDirection: "column",
      borderRadius: 18,
      overflowY: "auto",
      boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
      border: "2px solid #E0E0E0",
      background: "#fff",
      padding: 16,
      boxSizing: "border-box",
    }
    : {
      position: "fixed",
      top: 0,
      right: 0,
      width: 435,
      minWidth: 235,
      maxWidth: "85vw",
      height: "100vh",
      zIndex: 20,
      display: "flex",
      flexDirection: "column",
      background: "#F5F5F5",
      borderLeft: "1px solid #D9D9D9",
      borderRadius: 0,
      padding: 16,
      overflowY: "auto",
      boxSizing: "border-box",
    };

  const cardStyle = {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    background: "transparent",
  };

  const innerStyle = {
    width: "100%",
    maxWidth: isPopout ? 520 : 500,
    margin: "0 auto",
    padding: 20,
    borderRadius: 12,
    background: "#fff",
    boxShadow: "0 6px 24px rgba(202,36,32,0.18)",
    borderLeft: "4px solid rgba(202,36,32,0.85)",
    boxSizing: "border-box",
  };

  const actionsStyle = {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
    flexWrap: "wrap",
    marginTop: 12,
  };

  const buttonBase = {
    padding: "8px 12px",
    borderRadius: 8,
    cursor: "pointer",
    whiteSpace: "nowrap",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={innerStyle}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
            <div
              aria-hidden="true"
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                background: "rgba(202,36,32,0.85)",
                color: "#fff",
                display: "grid",
                placeItems: "center",
                fontWeight: 700,
                fontSize: 16,
                flexShrink: 0,
              }}
            >
              !
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, marginBottom: 6, color: "#1f2937" }}>Something went wrong</div>
              <div style={{ fontSize: "0.9rem", color: "#4b5563", marginBottom: 10 }}>{message}</div>
              {error?.message && (
                <code
                  style={{
                    display: "block",
                    background: "#f9fafb",
                    color: "#374151",
                    padding: "8px 10px",
                    borderRadius: 8,
                    fontSize: "0.85rem",
                    overflowX: "auto",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  {error.message}
                </code>
              )}
              <div style={actionsStyle}>
                {onClose && (
                  <button
                    type="button"
                    onClick={onClose}
                    style={{
                      ...buttonBase,
                      border: "1px solid #D1D5DB",
                      background: "#fff",
                      color: "#1f2937",
                    }}
                  >
                    Close
                  </button>
                )}
                {onRetry && (
                  <button
                    type="button"
                    onClick={onRetry}
                    style={{
                      ...buttonBase,
                      border: "1px solid rgba(202,36,32,0.85)",
                      background: "rgba(202,36,32,0.85)",
                      color: "#fff",
                    }}
                  >
                    Retry
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}